import { render } from "./Loading.vue?vue&type=template&id=0ef47a83"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__